import React from "react";
import { ModeRendererProps } from "./types";

export function RadarMode({ brand }: ModeRendererProps) {
  return (
    <g transform="translate(397 540)">
      {Array.from({ length: 6 }).map((_, i) => (
        <circle key={i} r={60 + i * 40} fill="none" stroke={brand.aqua} strokeOpacity={0.25} />
      ))}
      {Array.from({ length: 8 }).map((_, i) => (
        <line
          key={i}
          x1="0"
          y1="0"
          x2={280 * Math.cos((Math.PI / 4) * i)}
          y2={280 * Math.sin((Math.PI / 4) * i)}
          stroke={brand.violet}
          strokeOpacity="0.25"
        />
      ))}
      <path d="M0 0 L300 0 A300 300 0 0 1 260 150 Z" fill={brand.aqua} opacity="0.12" />
      {[
        [180, 60],
        [-120, 140],
        [60, -160],
        [-200, -80],
        [140, -40],
      ].map(([x, y], i) => (
        <g key={i}>
          <circle cx={x} cy={y} r="5" fill={brand.amber} />
          <circle cx={x} cy={y} r="10" fill="none" stroke={brand.amber} strokeOpacity="0.4" />
        </g>
      ))}
    </g>
  );
}
